﻿import ActivePage from "../activePage";

export default class PatCostEstimator extends ActivePage {

    constructor() {
        super();
        
    }

    initialize = (screen, id) => {        
        this.tabsLoaded = [];
        this.tabChangeSetListener();

        $(document).ready(() => {

            const countriesGrid = $(`#patCostEstimatorCountriesGrid`);
            countriesGrid.on("click", ".countryLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = countriesGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.Country);
                pageHelper.openLink(linkUrl, false);
            });
        });
    }

    initializeSidebarPage(sidebarPage) {
        //$(".kendo-Grid .k-grid-toolbar").addClass("sidebar-link");
        super.initializeSidebarPage(sidebarPage);
        this.sidebar.container.addClass("collapse-lg");
    }

    tabChangeSetListener = () => {
        const self = this;
        $('#patCostEstimator-tab a').on('click', (e) => {
            e.preventDefault();
            const tab = e.target.id;            
            if (this.tabsLoaded.indexOf(tab) === -1) {
                this.tabsLoaded.push(tab);
                this.loadTabContent(tab);
            }
            else if (tab == "costEstimatorDetailCountryTab") {
                const countryGrid = $("#patCostEstimatorCountriesGrid").data("kendoGrid");
                countryGrid.dataSource.read();
            }
        });

        this.fieldSetListener();
    }   

    fieldSetListener() {
        let form = $("#costEstimatorDetailsView-Content").find("form")[0];
        form = $(form);

        const self = this;
        $(document).ready(function () {
            
            form.find("input[name='Applicant']").each(function () {
                $(this).bind("click", function () {
                    var keyId = $("#KeyId").val();
                    if (keyId == 0) return true;

                    var confirmChange = confirm(form.data("label-applicant-change-confirm"));
                    if (confirmChange != true)
                        return false;
                });                
            });

            form.find("#chartShowBudget").each(function () {
                $(this).bind("click", function () {
                    const stackedChart = $("#countryCostStackedChart").data("kendoChart");
                    if (stackedChart) {
                        stackedChart.dataSource.read();
                    }
                });
            });
        });
    }       

    loadTabContent(tab) {
        switch (tab) {
            case "costEstimatorDetailCountryTab":
                $(document).ready(() => {
                    this.setCountriesGrid();
                });
                break;

            case "costEstimatorDetailAppDetailTab":
                $(document).ready(() => {
                    const countryGrid = $("#patCostEstimatorCountryDetailGrid").data("kendoGrid");
                    countryGrid.dataSource.read();
                    const questionCountryGrid = $("#patCEQuestionCountryGrid").data("kendoGrid");
                    questionCountryGrid.dataSource.read();
                    questionCountryGrid.table.on("click", ".answer-box", function () {
                        return false;
                    });  
                });
                break;

            case "costEstimatorDetailCostEstimateTab":
                $(document).ready(() => {                    
                    const grid = $("#patEstimatedCostsGrid").data("kendoGrid");
                    grid.dataSource.read();
                    
                    this.getEstimateCosts();

                    const stackedChart = $("#countryCostStackedChart").data("kendoChart");
                    if (stackedChart) {
                        stackedChart.dataSource.read();
                    }
                });
                break;

            case "":
                break;
        }
    }

    getEstimateCosts() {        
        let mainForm = $(`#${this.mainDetailContainer}`).find("form")[0];
        mainForm = $(mainForm);
        const getEstimateCostsUrl = mainForm.data("total-estimate-cost-url");
        const data = {
            id: $("#KeyId").val()            
        };

        $.get(getEstimateCostsUrl, data)
            .done((result) => {
                $("#viewModelEstimateCost").addClass('d-none');                
                $("#totalCostLabel").text(kendo.toString(result.totalCostEstimate, 'n0'));                   

                const countryCostTemplate = "<div class='col-4'><span style='text-decoration: none; font-weight: 500; color: var(--text-label);'><span>actualValue</span></span></div>";
                const countryContainer = $("#countryCostsContainer");
                countryContainer.empty();
                $.each(JSON.parse(result.countryCosts), function (index, item) {                   
                    var itemTemplate = countryCostTemplate.replace('actualValue', item.Category);
                    countryContainer.append(itemTemplate);
                });
                $("#jsEstimateCost").removeClass('d-none');
                pageHelper.updateRecordStamps(this);  
            })
            .fail((error) => {
                console.log('error: ', error);
            });
    }

    getParentTStamp = () => {
        const container = $(`#${this.detailContentContainer}`);
        const tStamp = container.find("input[name='tStamp']");
        return tStamp.val();
    }    

    //onBaseAppSelect = (e) => {        
    //    const baseCaseNumber = $("#baseCaseNumber");
    //    const baseCountry = $("#baseCountry");
    //    const baseSubCase = $("#baseSubCase");
    //    const appStatus = $("#baseApplicationStatus");
    //    const priorityDate = $("#basePriorityDate");

    //    baseCaseNumber.val(e.dataItem.CaseNumber);
    //    baseCountry.val(e.dataItem.Country);
    //    baseSubCase.val(e.dataItem.SubCase);
    //    appStatus.val(e.dataItem.ApplicationStatus);
    //    priorityDate.val(e.dataItem.PriorityDate);

    //    $("#AppId").val(e.dataItem.AppId);
    //    $("#InvId").val(e.dataItem.InvId);
    //    if (e.dataItem.AppId != 0) $("#InvId").val(0);
    //}

    onBaseAppChange = (e) => {       
        var dataItem = e.sender.dataItem();
        const baseCaseNumber = $("#baseCaseNumber");
        const baseCountry = $("#baseCountry");
        const baseSubCase = $("#baseSubCase");
        const appStatus = $("#baseApplicationStatus");
        const priorityDate = $("#basePriorityDate");        

        if (dataItem === undefined) {
            $("#AppId").val(0);
            $("#InvId").val(0);
            baseCaseNumber.val('');
            baseCountry.val('');
            baseSubCase.val('');
            appStatus.val('');
            priorityDate.val('');
        }
        else {
            baseCaseNumber.val(dataItem.CaseNumber);
            baseCountry.val(dataItem.Country);
            baseSubCase.val(dataItem.Subcase);
            appStatus.val(dataItem.ApplicationStatus);
            priorityDate.val(dataItem.ParentFilDate);

            $("#AppId").val(dataItem.AppId);
            $("#InvId").val(dataItem.InvId);
            if (dataItem.AppId != 0) $("#InvId").val(0);
        }
    }

    onCountryDetailGridChange = (e) => {
        const countriesGrid = $('#patCostEstimatorCountryDetailGrid').data('kendoGrid');        
        var dataItem = countriesGrid.dataItem(e.sender.select())

        if (dataItem) {
            const questionGrid = $('#patCEQuestionCountryGrid').data('kendoGrid');
            questionGrid.dataSource.read({ id: dataItem.KeyId, country: dataItem.Country });
            questionGrid.dataSource.page(1);
        }        
    }

    getSelectedCountry() {
        const countriesGrid = $('#patCostEstimatorCountryDetailGrid').data('kendoGrid');        
        var dataItem = countriesGrid.dataItem(countriesGrid.select())
        if (dataItem) {
            return { country: dataItem.Country };
        }        
    }
    
    setCountriesGrid() {
        const countriesMap = $("#costEstCountry-map").data("kendoMap");
        const el = $("#patCostEstimatorCountriesGrid")
        const grid = el.data("kendoGrid");
        const self = this;
        const popUpTitle = `<div class="h2"><div>Cost Estimator Countries</div></div>`;

        if (grid) {
            grid.dataSource.read();
            const parent = el.parent();

            el.find(".k-grid-toolbar").on("click",
                ".k-grid-AddCountries",
                function (e) {
                    self.generateCountryies("All", false);                    
                })               
        }
    }

    onEPOClick(e) {
        this.generateCountryies("EPO", e.checked);  
    }

    onPCTClick(e) {
        this.generateCountryies("PCT", e.checked);  
    }

    generateCountryies(countrySource, isChecked) {
        let mainForm = $(`#${this.mainDetailContainer}`).find("form")[0];
        mainForm = $(mainForm);
        const getCountryUrl = mainForm.data("show-countries-url");        
        const data = {
            id: $("#KeyId").val(),
            countrySource: countrySource,
            __RequestVerificationToken: $("[name='__RequestVerificationToken']").val()
        };

        const el = $("#patCostEstimatorCountriesGrid")
        const grid = el.data("kendoGrid");
        const countriesMap = $("#costEstCountry-map").data("kendoMap");

        const popUpTitle = mainForm.data("label-country-popup");        
        $.post(getCountryUrl, data)
            .done((result) => {
                cpiLoadingSpinner.hide();

                cpiConfirm.save(popUpTitle, result,
                    function () {

                        // get checked countries
                        let countries = [];
                        const countryTab = $("#costEstiamtorAllCountries");

                        $(countryTab.find("input")).each(function () {
                            //const ctryCode = $(this).attr("name");
                            const ceCountryID = $(this).attr("value");
                            if (this.checked && ceCountryID !== undefined) {
                                //countries += ctryCode + "|";
                                countries.push(ceCountryID);
                            }
                        });

                        if (countries.length < 0) {
                            throw "No countries selected.";
                        }
                        else {                           
                            const saveCountryUrl = mainForm.data("save-countries-url");
                            const data = {
                                id: $("#KeyId").val(),
                                countries: countries,
                                isChecked: isChecked,
                                countrySource: countrySource,
                                __RequestVerificationToken: $("[name='__RequestVerificationToken']").val()
                            }

                            $.post(saveCountryUrl, data)
                                .done(function (result) {
                                    cpiLoadingSpinner.hide();                                       
                                    patCostEstimatorPage.showDetails(patCostEstimatorPage.currentRecordId);
                                })
                                .fail((error) => {
                                    cpiLoadingSpinner.hide();

                                    cpiAlert.warning(pageHelper.getErrorMessage(error), function () {
                                        grid.dataSource.read();
                                        countriesMap.layers[1].dataSource.read();
                                    });
                                });
                        }
                    }, true,
                    function () {
                        patCostEstimatorPage.showDetails(patCostEstimatorPage.currentRecordId);
                    }, true);
            })
            .fail((error) => {
                cpiLoadingSpinner.hide();
                cpiAlert.warning(pageHelper.getErrorMessage(error), function () {
                    grid.dataSource.read();
                });
            });
    }

    markCopyCountries(check, container) {
        $("#" + container + " input").each(function () {
            this.checked = check;
        });
    }

    getCountry = (e) => {
        var grid = $("#patCostEstimatorCountriesGrid").data("kendoGrid");
        var selectedData = grid.dataItem(grid.select());
        return {
            country: selectedData.Country,
            keyId: selectedData.KeyId,
            request: e
        };
    }

    onChange_CountryCaseType = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#patCostEstimatorCountriesGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);

            const entityStatus = e.dataItem["EntityStatus"];   
            dataItem.EntityStatus = entityStatus;
            dataItem.CECountryId = e.dataItem["CECountryId"];

            //$(row).find(".entitystatus-field").html(entityStatus);
        }
    }

    afterInsert = (result) => {
        let id = result;
        if (isNaN(result))
            id = result.id;

        pageHelper.showDetails(this, id, () => {
            let isNewRec = result.isNewRec;
            if (isNewRec) {
                $(`#${this.mainDetailContainer}`).find("#costEstimatorDetailCountryTab").click();
                setTimeout(() => {
                    $('.k-grid-AddCountries').trigger('click');
                }, 500)
                
            }            
        });
    }

    showCopyScreen() {
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find("#patCostEstimatorCopyDialog");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        const self = this;

        entryForm = $(entryForm);
        const afterSubmit = function (result) {
            const dataContainer = $('#' + self.mainDetailContainer).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit });
    }
}
